import React from 'react';
import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';
import CustomTooltip from './CustomTooltip';

interface CustomButtonProps extends MuiButtonProps {
  tooltipLabel?: string;
  tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
  [key: string]: any;
}

const Button: React.FC<CustomButtonProps> = ({
  tooltipLabel,
  tooltipPosition = 'bottom',
  children,
  ...rest
}) => {
  // Remove any other custom props that shouldn't be passed to DOM
  const { mapType, icon, ...buttonProps } = rest;

  const button = (
    <MuiButton {...buttonProps}>
      {children}
    </MuiButton>
  );

  if (tooltipLabel) {
    return (
      <CustomTooltip title={tooltipLabel} placement={tooltipPosition} arrow>
        {button}
      </CustomTooltip>
    );
  }

  return button;
};

export { Button };